import React from "react";
import {
  FormatBold,
  FormatItalic,
  StrikethroughS,
  Code,
  FormatListNumbered,
  FormatListBulleted,
  FormatQuote,
  FormatUnderlined,
} from "@mui/icons-material";

/** Sintaxe WhatsApp (Meta): negrito * , itálico _ , riscado ~ , monoespaçado ``` */
const whatsappLikeFormats = [
  {
    key: "bold",
    tooltipKey: "input.format.bold",
    icon: <FormatBold fontSize="small" />,
    action: "*texto*",
  },
  {
    key: "italic",
    tooltipKey: "input.format.italic",
    icon: <FormatItalic fontSize="small" />,
    action: "_texto_",
  },
  {
    key: "strike",
    tooltipKey: "input.format.strike",
    icon: <StrikethroughS fontSize="small" />,
    action: "~texto~",
  },
  {
    key: "mono",
    tooltipKey: "input.format.mono",
    icon: <Code fontSize="small" />,
    action: "```texto```",
  },
  {
    key: "quote",
    tooltipKey: "input.format.quote",
    icon: <FormatQuote fontSize="small" />,
    spec: { type: "linePrefix", prefix: "> " },
  },
  {
    key: "bullet",
    tooltipKey: "input.format.bullet",
    icon: <FormatListBulleted fontSize="small" />,
    spec: { type: "linePrefix", prefix: "- " },
  },
  {
    key: "ordered",
    tooltipKey: "input.format.ordered",
    icon: <FormatListNumbered fontSize="small" />,
    spec: { type: "orderedLines" },
  },
];

const htmlBodyFormats = [
  {
    key: "bold",
    tooltipKey: "input.format.bold",
    icon: <FormatBold fontSize="small" />,
    action: "<b>texto</b>",
  },
  {
    key: "italic",
    tooltipKey: "input.format.italic",
    icon: <FormatItalic fontSize="small" />,
    action: "<i>texto</i>",
  },
  {
    key: "underline",
    tooltipKey: "input.format.underline",
    icon: <FormatUnderlined fontSize="small" />,
    action: "<u>texto</u>",
  },
  {
    key: "strike",
    tooltipKey: "input.format.strike",
    icon: <StrikethroughS fontSize="small" />,
    action: "<s>texto</s>",
  },
  {
    key: "code",
    tooltipKey: "input.format.code",
    icon: <Code fontSize="small" />,
    action: "<code>texto</code>",
  },
  {
    key: "quote",
    tooltipKey: "input.format.quote",
    icon: <FormatQuote fontSize="small" />,
    spec: { type: "htmlBlockquote" },
  },
  {
    key: "bullet",
    tooltipKey: "input.format.bullet",
    icon: <FormatListBulleted fontSize="small" />,
    spec: { type: "htmlUl" },
  },
  {
    key: "ordered",
    tooltipKey: "input.format.ordered",
    icon: <FormatListNumbered fontSize="small" />,
    spec: { type: "htmlOl" },
  },
];

/**
 * Opções por tipo de canal exibidas na barra contextual (texto selecionado).
 * Canais sem formatação no envio: lista vazia.
 */
export const composeChannelFormatOptions = {
  WhatsApp: whatsappLikeFormats,
  App: whatsappLikeFormats,
  Email: htmlBodyFormats,
  Wordpress: htmlBodyFormats,
  Messenger: [],
  Instagram: [],
  SMS: [],
};
